export default defineNuxtRouteMiddleware(async (to) => {
  const { $auth0, $auth0Ready, $groundcover } = useNuxtApp()

  if (to.meta.public) {
    return
  }

  if (import.meta.client) {
    await $auth0Ready()
    const { user } = $auth0()

    if (user.value) {
      const { email, name, sub } = user.value

      const roles = user.value?.['https://auth.rialtic.io/roles']

      $groundcover.identifyUser({
        id: sub,
        name,
        email,
        role: roles?.join(', ') ?? '',
        organization: email?.split('@')[1],
      })
    }
  }
})
